import { jsx as _jsx } from "react/jsx-runtime";
import { SettingCard } from 'z3k-settings/components/material-utils/settings-card/card';
import { MaterialBoolControl } from 'console/shared/components/fields';
import { ChangeGraphDialogItem } from './group-dialog-item';
export const GraphDialogGroupItem = (props) => {
    const { group_name, items, selectedSource, get_name_source_for_selected, update_item_color, update_item_checkbox, update_group_checkbox, } = props;
    const hasChecked = items.some((item) => {
        const name_item = get_name_source_for_selected(item);
        return selectedSource[group_name]?.[name_item]?.checked === true;
    });
    const hasUnchecked = items.some((item) => {
        const name_item = get_name_source_for_selected(item);
        return selectedSource[group_name]?.[name_item]?.checked === false;
    });
    return (_jsx(SettingCard, { container_props: {
            gap: 1,
            gridTemplateRows: 'repeat(auto-fill, minmax(35px, 1fr))',
            gridTemplateColumns: 'repeat(auto-fill, minmax(100%, 1fr))',
            ml: 2,
        }, title: _jsx(MaterialBoolControl, { color: "primary", label: group_name, value: !hasUnchecked, indeterminate: hasChecked && hasUnchecked, onChange: () => {
                update_group_checkbox(hasUnchecked, group_name);
            } }, group_name), children: items.map((item, idx) => (_jsx(ChangeGraphDialogItem, { item: item, group_name: group_name, selectedSource: selectedSource, update_item_color: update_item_color, update_item_checkbox: update_item_checkbox, get_name_source_for_selected: get_name_source_for_selected }, idx))) }, group_name));
};
